import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { CgEditHighlight } from "react-icons/cg";
import "./happenings_inner.css";

const API_BASE = process.env.REACT_APP_API_BASE_URL || "https://api.mitadtu.in";

const HappeningsInner = () => {
  const { id } = useParams();
  const [happenings, setHappenings] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchHappening = async () => {
      try {
        const res = await fetch(`${API_BASE}/api/admin/latest-news/public`);
        const result = await res.json();

        const firstItem = (result.happenings || []).find(
          (item) => String(item.id) === String(id),
        );

        if (firstItem) {
          const sameOrderItems = (result.happenings || []).filter(
            (item) => item.display_order === firstItem.display_order,
          );

          setHappenings(sameOrderItems);
        }
      } catch (err) {
        console.error("Error:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchHappening();
  }, [id]);

  if (loading) return <p>Loading...</p>;
  if (happenings.length === 0) return <p>No data found</p>;

  return (
    <div className="happenings-inner-wrapper">
      {happenings.map((data) => {
        const photos = Array.isArray(data.news_photo) ? data.news_photo : [];

        return (
          <div key={data.id} className="happening-inner-card">
            <div className="happening-top">
              <h3 className="happening-heading">{data.news_title}</h3>

              {data.news_date && (
                <p className="happenings-date" style={{ marginLeft: "auto" }}>
                  {data.news_date}
                </p>
              )}
            </div>
            {photos.length > 0 && (
              <div className="happening-inner-gallery">
                {photos.map((photo, i) => (
                  <img
                    key={i}
                    src={`${API_BASE}${photo}`}
                    alt={data.news_title}
                  />
                ))}
              </div>
            )}

            {data.description.split("\n").map((para, index) => (
              <p key={index}>{para}</p>
            ))}
          </div>
        );
      })}
    </div>
  );
};

export default HappeningsInner;
